exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".NameChanger__NameChanger__1kKfi h2 {\n    margin-top: 0.5rem;\n    margin-bottom: 0;\n    font-size: 1.5rem;\n}\n.NameChanger__NameChanger__1kKfi form {\n    margin-top: 0;\n}\n\n.NameChanger__NameChanger__1kKfi form input {\n    margin-top: 1rem;\n}\n\n.NameChanger__disabled__1o1OG {\n    background-color: #74c29e !important;\n    cursor: default !important;\n}\n.NameChanger__disabled__1o1OG:hover,\n.NameChanger__disabled__1o1OG:active,\n.NameChanger__disabled__1o1OG:focus {\n    background-color: #74c29e !important;\n    cursor: default !important;\n}", ""]);

// exports
exports.locals = {
	"NameChanger": "NameChanger__NameChanger__1kKfi",
	"disabled": "NameChanger__disabled__1o1OG"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/containers/Company/NameChanger/NameChanger.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/containers/Company/NameChanger/NameChanger.css
// module chunks = 0